var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect } from 'react';
import { Error, Footer, Header } from '@/presentation/components';
import { SurveyListItem, surveyListState } from './components';
import Styles from './survey-list-styles.scss';
import { useErrorHandler } from '@/presentation/hooks';
import { useRecoilState, useResetRecoilState } from 'recoil';
const SurveyList = ({ loadSurveyList }) => {
    const resetSurveyListState = useResetRecoilState(surveyListState);
    const handleError = useErrorHandler((error) => {
        setState(prev => (Object.assign(Object.assign({}, prev), { error: error.message, reload: false })));
    });
    const [state, setState] = useRecoilState(surveyListState);
    const reload = () => setState(prev => ({ surveys: [], error: '', reload: !prev.reload }));
    useEffect(() => resetSurveyListState(), []);
    useEffect(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const surveys = yield loadSurveyList.all();
                setState(prev => (Object.assign(Object.assign({}, prev), { surveys, reload: false })));
            }
            catch (error) {
                handleError(error);
            }
        }))();
    }, [state.reload]);
    return (React.createElement("div", { className: Styles.surveyListWrap },
        React.createElement(Header, null),
        React.createElement("div", { className: Styles.contentWrap },
            React.createElement("h2", null, "Surveys"),
            state.error ? React.createElement(Error, { error: state.error, reload: reload }) : React.createElement(SurveyListItem, { surveys: state.surveys })),
        React.createElement(Footer, null)));
};
export default SurveyList;
